namespace FeatureNames {
  // Gateway
  export const tcuWifi = 'tcu.wifi';
  export const tcuMode = 'tcu.mode';
  export const gatewayStatus = 'gateway.status';
  export const gatewayDevices = 'gateway.devices';
  export const gatewayFirmware = 'gateway.firmware';
  export const gatewayRemoteDiagnostics = 'gateway.remoteDiagnostics';

  // Device
  export const deviceZigbeeLqi = 'device.zigbee.lqi';
  export const deviceZigbeeParent = 'device.zigbee.parent.id';
  export const deviceZigbeeParentRx = 'device.zigbee.parent.rx';
  export const deviceZigbeeParentTx = 'device.zigbee.parent.tx';
  export const deviceZigbeeCoordinator = 'device.zigbee.coordinator';
  export const deviceZigbeeActive = 'device.zigbee.active';
  export const devicePowerBattery = 'device.power.battery';
  export const deviceHeatingCircuitId = 'device.heatingCircuitId';
  export const deviceConnection = 'device.connection';
  export const deviceBusTopology = 'device.busTopology';
  export const deviceParameterIdentificationVersion = 'device.parameterIdentification.version';
  export const deviceSensorsCo2 = 'device.sensors.co2';
  export const deviceThirdpartyManufacturer = 'device.thirdparty.manufacturer';
  export const deviceThirdpartyModel = 'device.thirdparty.model';
  export const deviceThirdpartySoftware = 'device.thirdparty.version.software';
  export const deviceEtn = 'device.etn';
  export const deviceProductIdentification = 'device.productIdentification';
  export const deviceProductMatrix = 'device.productMatrix';
  export const devicePvSignalActive = 'device.pvSignal.active';
  export const devicePvSignal = 'device.pvSignal';
  export const deviceOffPeakSignal = 'device.offPeakSignal';
  export const deviceOffPeakSignalConfiguration = 'device.offPeakSignal.configuration';
  export const deviceMessageErrorsRaw = 'device.messages.errors.raw';
  export const deviceRemoteReset = 'device.remoteReset';
  export const deviceConfiguration = 'device.configuration';
  export const deviceDemandExternal = 'device.demand.external';
  export const deviceLockExternal = 'device.lock.external';
  export const deviceDemandExternalFlowTemperatureSetpoint =
    'device.demand.external.flow.temperature.setpoint';
  export const deviceBus = 'device.bus';

  // Floor Heating Thermostat
  export const fhtActiveOperatingMode = 'fht.operating.modes.active';
  export const fhtChannels = 'fht.channels';
  export const fhtSensorsTemperatureSupply = 'fht.sensors.temperature.supply';
  export const fhtDamageProtectionThreshold =
    'fht.configuration.floorHeatingDamageProtectionThreshold';
  export const fhtChannelValve = 'fht.valve';
  export const fhtChannelValvePosition = 'fht.valve.position';
  export const fhtChannelBurnInMode = 'fht.valve.burnInMode';
  export const fhtDemandRelayMode = 'fht.configuration.demandRelayMode';

  // Gas Configuration
  export const gasConfigurationType = 'heating.gas.configuration.type';
  export const gasConfigurationCalorificValue = 'heating.gas.configuration.calorificValue';
  export const gasConfigurationCorrectionFactor =
    'heating.gas.configuration.volumeCorrectionFactor';

  // Gas consumption
  export const gasConsumptionHeating = 'heating.gas.consumption.heating';
  export const gasConsumptionDhw = 'heating.gas.consumption.dhw';
  export const gasConsumptionFuelCell = 'heating.gas.consumption.fuelCell';
  export const gasConsumptionTotal = 'heating.gas.consumption.total';
  export const heatingDhwActuator = 'heating.dhw.actuator';

  // Gas consumption total
  export const gasConsumptionSummaryHeating = 'heating.gas.consumption.summary.heating';
  export const gasConsumptionSummaryDhw = 'heating.gas.consumption.summary.dhw';

  //Power consumption total
  export const powerConsumptionSummaryDhw = 'heating.power.consumption.summary.dhw';
  export const powerConsumptionSummaryHeating = 'heating.power.consumption.summary.heating';

  // Power consumption
  export const powerElectricalConsumptionHeating = 'heating.heatingRod.power.consumption.heating';
  export const powerElectricalConsumptionDhw = 'heating.heatingRod.power.consumption.dhw';
  export const powerCompressorConsumptionHeating =
    'heating.compressors.0.power.consumption.heating';
  export const powerCompressorConsumptionDhw = 'heating.compressors.0.power.consumption.dhw';
  export const powerConsumptionTotal = 'heating.power.consumption.total';
  export const powerConsumptionCooling = 'heating.power.consumption.cooling';
  export const powerConsumptionHeating = 'heating.power.consumption.heating';
  export const powerConsumptionDhw = 'heating.power.consumption.dhw';
  export const powerCompressor = 'heating.compressors.0.power';

  // Primary circuit
  export const primaryCircuitAirSource = 'heating.primaryCircuit.airSource';

  // Autarky
  export const heatingPowerProductionDemandCoverageRaw =
    'heating.power.production.demandCoverage.raw';

  // Heating Sensors
  export const outsideTemperature = 'heating.sensors.temperature.outside';
  export const returnFlowTemperature = 'heating.sensors.temperature.return';
  export const returnIncreasedTemperature = 'heating.sensors.temperature.increasedReturn';
  export const returnSystemReturnTemperature = 'heating.sensors.temperature.systemReturn';
  export const hydraulicSeparatorTemperature = 'heating.sensors.temperature.hydraulicSeparator';
  export const waterPressure = 'heating.sensors.pressure.supply';
  export const volumetricFlowReturn = 'heating.sensors.volumetricFlow.allengra';
  export const powerOutput = 'heating.power.production.current';
  export const increasedReturnTemperature = 'heating.increasedReturn.temperature';
  export const threeWayValve = 'heating.sensors.valve.bufferDischargeThreeWayValve';
  export const bufferCylinderTemperatureMain = 'heating.bufferCylinder.sensors.temperature.main';
  export const bufferTemperatureStratification =
    'heating.buffer.sensors.temperature.stratification';

  // Heating Secondary Circuit Sensors
  export const secondaryHeatGenerator = 'heating.secondaryHeatGenerator';
  export const secondaryCircuitSupplyTemperature =
    'heating.secondaryCircuit.sensors.temperature.supply';
  export const secondaryValvesFourThreeWay = 'heating.secondaryCircuit.valves.fourThreeWay';
  export const secondaryValvesFourThreeWayPosition = 'heating.valves.fourThreeWay.position';
  export const secondaryHeatGeneratorTemperatureSeparator =
    'heating.secondaryHeatGenerator.sensors.temperature.separator';
  export const secondaryHeatGeneratorConfiguration = 'heating.configuration.secondaryHeatGenerator';
  export const secondaryHeatGeneratorOperatingModesActive =
    'heating.secondaryHeatGenerator.operating.modes.active';
  export const secondaryHeatGeneratorTemperatureOffset =
    'heating.secondaryHeatGenerator.temperature.offset';
  export const secondaryHeatGeneratorFossilPriceNormal =
    'heating.secondaryHeatGenerator.fossil.price.normal';
  export const secondaryHeatGeneratorlElectricityPriceNormal =
    'heating.secondaryHeatGenerator.electricity.price.normal';
  export const secondaryHeatGeneratorlElectricityPriceLow =
    'heating.secondaryHeatGenerator.electricity.price.low';
  export const secondaryHeatGeneratorElectricityEnergyFactor =
    'heating.secondaryHeatGenerator.electricity.energyFactor';
  export const secondaryHeatGeneratorFossilEnergyFactor =
    'heating.secondaryHeatGenerator.fossil.energyFactor';
  export const secondaryHeatGeneratorElecticityPriceSchedule =
    'heating.secondaryHeatGenerator.electricity.price.schedule';
  export const secondaryHeatGeneratorBivalencePoint =
    'heating.secondaryHeatGenerator.temperature.bivalencePoint';
  export const secondaryHeatGeneratorAlternativePoint =
    'heating.secondaryHeatGenerator.temperature.alternativePoint';
  export const secondaryHeatGeneratorConfigurationRuntime =
    'heating.secondaryHeatGenerator.configuration.runtime';
  export const secondaryHeatGeneratorConfigurationTimeIntegralThreshold =
    'heating.secondaryHeatGenerator.configuration.timeIntegralThreshold';
  export const secondaryHeatGeneratorDhwOffset = 'heating.secondaryHeatGenerator.dhw.offset';

  // Heating Boiler Sensors
  export const boilerTemperature = 'heating.boiler.sensors.temperature.main';
  export const heatingBoilerTemperature = 'heating.boiler.temperature';
  export const boilerCommonSupplyTemperature = 'heating.boiler.sensors.temperature.commonSupply';
  export const boilerPumpsInternal = 'heating.boiler.pumps.internal';
  export const boilerPumpsInternalTarget = 'heating.boiler.pumps.internal.target';
  export const boilerPumpsInternalCurrent = 'heating.boiler.pumps.internal.current';
  // Burner
  export const burnerStatus = 'heating.burners.0';
  export const burnerStatistics = 'heating.burners.0.statistics';
  export const burnerModulation = 'heating.burners.0.modulation';
  export const burnerErrorStatus = 'heating.burners.0.errorStatus';
  export const burnerDemandTemperature = 'heating.burners.0.demand.temperature';
  export const burnerManualActivation = 'heating.burners.0.manualActivation';

  // Compressors
  export const compressorStatus = 'heating.compressors.0';
  export const compressorStatistics = 'heating.compressors.0.statistics';
  export const compressorStatisticsLoad = 'heating.compressors.0.statistics.load';
  export const compressors = 'heating.compressors';
  export const singleCompressorStatus = (compressorId: string) =>
    `heating.compressors.${compressorId}`;
  export const singleCompressorStatisticsLoad = (compressorId: string) =>
    `heating.compressors.${compressorId}.statistics.load`;
  export const singleCompressorStatistics = (compressorId: string) =>
    `heating.compressors.${compressorId}.statistics`;
  export const coolingCircuitMessages = (refrigerantId: string) =>
    `heating.coolingCircuits.${refrigerantId}.messages`;
  export const singleCompressorHeatProductionCurrent = (compressorId: string) =>
    `heating.compressors.${compressorId}.heat.production.current`;
  export const singleCompressorRelativeSpeedSetpoint = (compressorId: string) =>
    `heating.compressors.${compressorId}.relativeSpeed.setpoint`;
  export const coolingCircuitType = 'heating.coolingCircuits.0.type';
  export const coolingCircuitEevType = 'heating.coolingCircuits.0.eev.type';
  export const heatingCoolingCircuitsRemoteDefrost = 'heating.coolingCircuits.0.defrost';
  export const compressorSpeedCurrent = 'heating.compressors.0.speed.current';

  // Configuration
  export const configurationCooling = 'heating.configuration.cooling';
  export const configurationMultiFamilyHouse = 'heating.configuration.multiFamilyHouse';
  export const configurationRegulation = 'heating.configuration.regulation';
  export const configurationFuelCapacity = 'heating.configuration.fuel.capacity';
  export const configurationInternalPumps = 'heating.configuration.internalPumps';
  export const configurationdhwCylinderPumps = 'heating.configuration.dhwCylinderPump';

  // Domestic Hot Water
  export const dhw = 'heating.dhw';
  export const dhwRustSurveillanceAnode = 'heating.dhw.sensors.dhwCylinder.rustSurveillance.anode';
  export const dhwMainTemperature = 'heating.dhw.temperature.main';
  export const dhwTemp2Temperature = 'heating.dhw.temperature.temp2';
  export const dhwMinimumComfort = 'heating.dhw.configuration.temperature.minimumComfort';
  export const dhwTemperatureHysteresis = 'heating.dhw.temperature.hysteresis';
  export const dhwOneTimeCharge = 'heating.dhw.oneTimeCharge';
  export const dhwSchedule = 'heating.dhw.schedule';
  export const dhwScheduleMode = 'heating.dhw.schedule.mode';
  export const dhwPumpsCirculationSchedule = 'heating.dhw.pumps.circulation.schedule';
  export const dhwPumpsCirculation = 'heating.dhw.pumps.circulation';
  export const dhwPumpsPrimary = 'heating.dhw.pumps.primary';
  export const dhwPumpsSecondary = 'heating.dhw.pumps.secondary';
  export const dhwDryContact = 'heating.dhw.configuration.dryContact';
  export const dhwEcoModeLeading = 'heating.dhw.configuration.sensors.ecoMode.leading';
  export const dhwTemperatureComfortCharging =
    'heating.dhw.configuration.temperature.comfortCharging';

  export const dhwActiveOperatingMode = 'heating.dhw.operating.modes.active';
  export const dhwConfigurationPumpsCirculationMode =
    'heating.dhw.pumps.circulation.operating.modes.active';
  export const dhwConfigurationPumpsCirculationTriggerCycleDuration =
    'heating.dhw.configuration.pumps.circulation.triggerCycleDuration';
  export const dhwConfigurationPumpsCirculationParallelHygiene =
    'heating.dhw.configuration.pumps.circulation.parallelHygiene';
  export const dhwConfigurationPumpsCirculationParallelDhwHeating =
    'heating.dhw.configuration.pumps.circulation.parallelDhwHeating';
  export const dhwConfigurationPumpsCirculationCycleConfiguration =
    'heating.dhw.configuration.pumps.circulation.cycleConfiguration';
  export const dhwHygiene = 'heating.dhw.hygiene';
  export const dhwHygieneTrigger = 'heating.dhw.hygiene.trigger';

  // Heating SOP
  export const heatingCopTotal = 'heating.cop.total';
  export const heatingCopHeating = 'heating.cop.heating';
  export const heatingCopDhw = 'heating.cop.dhw';
  export const heatingCopCooling = 'heating.cop.cooling';
  export const heatingCopPhotovoltaic = 'heating.cop.photovoltaic';

  // Heating spf
  export const heatingSpfTotal = 'heating.spf.total';
  export const heatingSpfHeating = 'heating.spf.heating';
  export const heatingSpfDhw = 'heating.spf.dhw';

  export const storageTankSensor = 'heating.dhw.sensors.temperature.dhwCylinder';
  export const storageTankSensorTop = 'heating.dhw.sensors.temperature.dhwCylinder.top';
  export const storageTankSensorMiddle = 'heating.dhw.sensors.temperature.dhwCylinder.middle';
  export const storageTankSensorMidBottom = 'heating.dhw.sensors.temperature.dhwCylinder.midBottom';
  export const storageTankSensorBottom = 'heating.dhw.sensors.temperature.dhwCylinder.bottom';
  export const heatDhwDiverter = 'heating.valves.diverter.heatDhw';
  // Seer
  export const heatingSeerCooling = 'heating.seer.cooling';

  // Heating device
  export const heatingDevice = 'heating.device';
  export const heatingDeviceTime = 'heating.device.time';
  export const heatingDeviceTimeSource = 'heating.device.time.source';
  export const heatingDeviceTimeOffset = 'heating.device.time.offset';
  export const heatingDeviceComfortEnsuring = 'heating.device.comfortEnsuring';
  export const heatingDeviceStatus = 'heating.device.status';
  export const heatingDeviceFuelCurrent = 'heating.device.fuel.current';
  export const heatingDeviceFuelMinimal = 'heating.device.fuel.minimal';

  // Emergency operation
  export const heatingDeviceEmergencyOperation = 'heating.device.emergencyOperation';

  // SRC
  export const rooms = 'rooms';
  export const roomStatus = 'rooms.status';
  export const roomFirmware = 'rooms.firmware';
  export const deviceName = 'device.name';
  export const etrvPowerBattery = 'trv.power.battery';
  export const etrvTemperature = 'trv.temperature';
  export const etrvMountingMode = 'trv.mountingMode';
  export const etrvValvePosition = 'trv.valve.position';
  export const deviceTemperatureSensor = 'device.sensors.temperature';
  export const deviceHumiditySensor = 'device.sensors.humidity';
  export const standaloneMode = 'rooms.standaloneMode';
  export const condensateAvoidance = 'rooms.features.condensateAvoidance';
  export const roomsFeatures = 'rooms.features';
  export const srcChannelFTDC = (channelId: string) =>
    `rooms.features.supplyChannel${channelId}FTDC`;
  export const roomDetails = (roomId: string) => `rooms.${roomId}`;
  export const roomSchedule = (roomId: string) => `rooms.${roomId}.schedule`;
  export const roomQuickModesProgram = (roomId: string, program: string) =>
    `rooms.${roomId}.quickmodes.${program}`;
  export const roomTemperature = (roomId: string) => `rooms.${roomId}.sensors.temperature`;
  export const roomHumidity = (roomId: string) => `rooms.${roomId}.sensors.humidity`;
  export const roomGeofencing = (roomId: string) => `rooms.${roomId}.geofencing`;
  export const roomOpenPointDetectionActivity = (roomId: string) => `rooms.${roomId}.opd.activity`;
  export const roomHeatUpSpeed = (roomId: string) => `rooms.${roomId}.configuration.heatUpSpeed`;
  export const condensationRisk = (roomId: string) => `rooms.${roomId}.condensationRisk`;
  export const roomOperatingState = (roomId: string) => `rooms.${roomId}.operating.state`;
  export const roomQuickModesManual = (roomId: string) => `rooms.${roomId}.quickmodes.manual`;
  export const roomQuickModesManualTillNextSchedule = (roomId: string) =>
    `rooms.${roomId}.quickmodes.manualTillNextSchedule`;
  export const roomLevelsHeating = (roomId: string) => `rooms.${roomId}.temperature.levels.heating`;
  export const roomLevelsCooling = (roomId: string) => `rooms.${roomId}.temperature.levels.cooling`;
  export const roomTemperatureLevelsPerceived = (roomId: string, programName: string) =>
    `rooms.${roomId}.temperature.levels.${programName}.perceived`;
  export const srcOperatingProgram = (roomId: string, program: string, isOtherRoom = false) =>
    `rooms.${isOtherRoom ? 'others.' : ''}${roomId}.operating.programs.${program}`;
  export const srcChannelPumpControl = (pumpId: string) =>
    `rooms.features.supplyChannel${pumpId}PumpControl`;
  export const roomControlMode = (roomId: string) => `rooms.${roomId}.control.mode.active`;

  export const roomSensorsCo2 = (roomId: string) => `rooms.${roomId}.sensors.co2`;
  export const roomCo2 = (roomId: string) => `rooms.${roomId}.co2`;
  export const childLock = (roomId: string) => `rooms.${roomId}.childLock`;
  export const configurationOpenWindow = (roomId: string) =>
    `rooms.${roomId}.configuration.openWindow`;

  // SRC Other rooms
  export const otherRooms = 'rooms.others';
  export const otherRoomDetails = (roomId: string) => `rooms.others.${roomId}`;
  export const otherRoomSchedule = (roomId: string) => `rooms.others.${roomId}.schedule`;
  export const otherRoomOperatingProgram = (roomId: string, program: string) =>
    `rooms.others.${roomId}.operating.programs.${program}`;
  export const otherRoomTemperature = (roomId: string) =>
    `rooms.others.${roomId}.sensors.temperature`;
  export const otherRoomHumidity = (roomId: string) => `rooms.others.${roomId}.sensors.humidity`;
  export const otherRoomGeofencing = (roomId: string) => `rooms.others.${roomId}.geofencing`;
  export const otherRoomOperatingState = (roomId: string) =>
    `rooms.others.${roomId}.operating.state`;
  export const otherRoomLevelsHeating = (roomId: string) =>
    `rooms.others.${roomId}.temperature.levels.heating`;
  export const otherRoomLevelsCooling = (roomId: string) =>
    `rooms.others.${roomId}.temperature.levels.cooling`;
  export const otherRoomTemperatureLevelsPerceived = (roomId: string, programName: string) =>
    `rooms.others.${roomId}.temperature.levels.${programName}.perceived`;

  // Energy Cockpit
  export const powerCumulativeProduced = 'heating.power.production.cumulative';
  export const powerCumulativePurchased = 'heating.power.purchase.cumulative';
  export const powerCumulativeSold = 'heating.power.sold.cumulative';
  export const powerProductionCurrent = 'heating.power.production.current';
  export const powerLimitationOverview = 'power.limitation.overview';

  // Power
  export const energyProductionTotal = 'ems.energy.production.total';
  export const energyConsumptionTotal = 'ems.energy.consumption.total';
  export const energyGridFeedIn = 'ems.energy.grid.feed-in';
  export const energyGridConsumption = 'ems.energy.grid.consumption';
  export const energyBatteryCharge = 'ems.energy.storage.charge';
  export const energyBatteryDischarge = 'ems.energy.storage.discharge';
  export const energyBatteryStateOfCharge = 'ess.stateOfCharge.consolidated/total';
  export const kpiAutarky = 'ems.kpi.autarky';
  export const kpiSelfConsumption = 'ems.kpi.self-consumption';
  export const energyHeatPumpConsumption = 'ems.energy.consumption.heat-pump';
  export const energyHouseholdConsumption = 'ems.energy.consumption.household';
  export const emsCarbonSavings = 'ems.carbon.savings';
  export const emsCarbonEmissions = 'ems.carbon.emissions';

  // Thermal
  export const heatPumpConsumption = 'electricity.consumption.total';
  export const compressorConsumption = 'electricity.consumption.device.compressor';
  export const electricHeaterConsumption = 'electricity.consumption.device.electricHeater';
  export const heatingConsumption = 'electricity.consumption.usage.centralHeating';
  export const hotWaterConsumption = 'electricity.consumption.usage.domesticHotWater';
  export const coolingConsumption = 'electricity.consumption.usage.cooling';
  export const thermalOutputTotal = 'thermal.output.total';
  export const heatingOutput = 'thermal.output.usage.centralHeating';
  export const hotWaterOutput = 'thermal.output.usage.domesticHotWater';
  export const coolingOutput = 'thermal.output.usage.cooling';
  export const legacyHeatPumpConsumption = 'electricity.consumption.heatpump.total';
  export const legacyBoilerFuelConsumption = 'dl.heating.device.fuel.delta';
  // thermal.cockpit
  export const thermalCockpit = 'thermal.cockpit';

  // EMS
  export const emsPowerBalance = 'ems.power.balance';
  export const emsPowerFlows = 'ems.power.flows';
  export const emsKeyPerformanceIndicators = 'ems.kpi';
  export const hocaFeatures = 'ems.hoca.features';
  export const photovoltaicExcessHeatpumpHandling =
    'ems.hoca.features.photovoltaicExcessToHeatpump';
  export const photovoltaicExcessPvHandling = 'ems.hoca.features.photovoltaicExcessToPvHeater';
  export const onlineSolarIrradianceForecast = 'ems.hoca.features.onlineSolarIrradianceForecast';
  export const forecastBasedBatteryOperation = 'ems.hoca.features.forecastBasedBatteryOperation';
  export const overloadProtection = 'ems.hoca.features.vcsOverloadProtection';
  export const gridCurrentLimit = 'ems.grid.current.limit';
  export const emsEnergyConsumptionVcs = 'ems.energy.consumption.vcs';
  export const emsEnergyConsumptionPvImmersionHeater = 'ems.energy.consumption.pv.immersion.heater';
  export const emsEnergyProductionToConsumption = 'ems.energy.production.to.consumption';
  export const emsHocaFeaturesTariffBasedFinancialOptimizationState =
    'ems.hoca.features.tariffBasedFinancialOptimization.state';
  export const emsHocaFeaturesAllowBatteryChargingFromTheGrid =
    'ems.hoca.features.allowBatteryChargingFromTheGrid';
  export const emsHocaFeaturesHeatpumpOnly = 'ems.hoca.features.heatpumpOnly';
  // PV Immersion Heater
  export const pvHeaterPowerConsumptionCurrent = 'heating.pvHeater.power.consumption.current';
  export const emsEnergyPVExcessToDryContact = (feature: string) => `ems.hoca.features.${feature}`;

  // Ventilation
  export const ventilation = 'ventilation';
  export const ventilationSchedule = 'ventilation.schedule';
  export const ventilationMode = 'ventilation.operating.modes.active';
  export const ventilationProgram = 'ventilation.operating.programs.active';
  export const ventilationPermanent = 'ventilation.operating.modes.permanent';
  export const ventilationBypass = 'ventilation.bypass';
  export const ventilationBypassMode = 'ventilation.bypass.operating.modes.active';
  export const ventilationBypassConfiguration = 'ventilation.bypass.configuration';
  export const ventilationBypassPosition = 'ventilation.bypass.position';
  export const ventilationBypassConfigurationTemperatureSupply =
    'ventilation.bypass.configuration.temperature.supply';
  export const ventilationBypassConfigurationTemperaturePerceived =
    'ventilation.bypass.configuration.temperature.perceived';
  export const ventilationAutomatedModeLevel =
    'ventilation.operating.modes.configuration.sensorDriven.limits';
  export const ventilationRemoteController = 'ventilation.remoteController';

  export const ventilationProgramLevels = {
    levelOne: 'ventilation.levels.levelOne',
    levelTwo: 'ventilation.levels.levelTwo',
    levelThree: 'ventilation.levels.levelThree',
    levelFour: 'ventilation.levels.levelFour',
  };
  export const ventilationHeatExchangerFrostprotection =
    'ventilation.heatExchanger.frostprotection';
  export const preHeaterStatistics = 'ventilation.preHeater.statistics';
  export const filterRuntime = 'ventilation.filter.runtime';

  export const ventilationFanExhaust = 'ventilation.fan.exhaust';
  export const ventilationFanExhaustRuntime = 'ventilation.fan.exhaust.runtime';
  export const ventilationFanSupply = 'ventilation.fan.supply';
  export const ventilationFanSupplyRuntime = 'ventilation.fan.supply.runtime';
  export const ventilationHeatRecovery = 'ventilation.heating.recovery';
  export const ventilationQuickmodesSilent = 'ventilation.quickmodes.silent';
  export const ventilationQuickmodesForcedLevelFour = 'ventilation.quickmodes.forcedLevelFour';
  export const ventilationQuickmodesTemporaryShutdown = 'ventilation.quickmodes.temporaryShutdown';
  export const ventilationState = 'ventilation.operating.state';
  export const ventilationFilterPollutionBlocked = 'ventilation.filter.pollution.blocked';

  export const ventilationVolumeFlowCurrentOutput = 'ventilation.volumeFlow.current.output';

  export const ventilationVolumeFlowCurrentInput = 'ventilation.volumeFlow.current.input';

  export const ventilationSensorsTemperatureSupply = 'ventilation.sensors.temperature.supply';
  export const ventilationSensorsHumiditySupply = 'ventilation.sensors.humidity.supply';
  export const ventilationSensorsTemperatureOutside = 'ventilation.sensors.temperature.outside';
  export const ventilationSensorsHumidityOutdoor = 'ventilation.sensors.humidity.outdoor';
  export const ventilationSensorsTemperatureExhaust = 'ventilation.sensors.temperature.exhaust';
  export const ventilationSensorsHumidityExhaust = 'ventilation.sensors.humidity.exhaust';
  export const ventilationSensorsTemperatureExtract = 'ventilation.sensors.temperature.extract';
  export const ventilationSensorsHumidityExtract = 'ventilation.sensors.humidity.extract';
  export const ventilationHeatExchangerType = 'ventilation.heatExchanger.type';
  export const ventilationHeatExchangerFrostprotectionOperatingModesActive =
    'ventilation.heatExchanger.frostprotection.operating.modes.active';
  export const ventilationPreHeater = 'ventilation.preHeater';
  // Electric Heater
  export const heatingRodGeneral = 'heating.configuration.heatingRod.general';
  export const heatingRodHeating = 'heating.configuration.heatingRod.heating';
  export const heatingRodDhw = 'heating.configuration.heatingRod.dhw';
  export const heatingRodStatus = 'heating.heatingRod.status';
  export const heatingRodStatistics = 'heating.heatingRod.statistics';
  export const heatingRodMaximumOutsideTemperature = 'heating.heatingRod.maximumOutsideTemperature';
  export const heatingConfigurationDhwHeater = 'heating.configuration.dhwHeater';
  export const heatingConfigurationSecondaryHeatGeneratorModeOnError =
    'heating.configuration.secondaryHeatGenerator.modeOnError';

  // Solar
  export const solarStatistics = 'heating.solar.statistics';
  export const solarRechargeSuppression = 'heating.solar.rechargeSuppression';
  export const solarDhwTemperature = 'heating.solar.sensors.temperature.dhw';
  export const solarCollectorTemperature = 'heating.solar.sensors.temperature.collector';
  export const solarCumulativeProduced = 'heating.solar.power.cumulativeProduced';
  export const solarPowerProduction = 'heating.solar.power.production';
  export const solarPumps = 'heating.solar.pumps.circuit';
  export const solar = 'heating.solar';
  export const solarSurfaceNetIrradiance = 'heating.solar.forecast.surfaceNetIrradiance';
  export const solarStatus = 'heating.solar.status';

  // Fuel Cell
  export const fuelCell = 'fuelCell';
  export const fuelCellActiveMode = 'fuelCell.operating.modes.active';
  export const fuelCellReturnTemperature = 'fuelCell.sensors.temperature.return';
  export const fuelCellSupplyTemperature = 'fuelCell.sensors.temperature.supply';
  export const fuelCellOperatingPhase = 'fuelCell.operating.phase';
  export const fuelCellStatistics = 'fuelCell.statistics';
  export const fuelCellPowerProduction = 'fuelCell.power.production';

  // Photovoltaic
  export const photovoltaicStatus = 'photovoltaic.status';
  export const photovoltaicOverview = 'photovoltaic.overview';
  export const essPhotovoltaicState = 'ess.photovoltaic.state';
  export const photovoltaicCumulatedEnergy = 'photovoltaic.production.cumulated';
  export const photovoltaicInstalledPeakPowerConsolidated =
    'photovoltaic.installedPeakPower.consolidated';
  export const photovoltaicInstalledPeakPower = 'photovoltaic.installedPeakPower';
  export const productionCurrentConsolidated = 'photovoltaic.production.current.consolidated';
  export const productionCurrent = 'photovoltaic.production.current';
  export const photovoltaicInsulationResistance = 'photovoltaic.insulationResistance.system';
  export const photovoltaicStringIdElectricity = (pvStringId: string) =>
    `photovoltaic.string.${pvStringId}.electricity`;
  export const photovoltaicStringIdPower = (pvStringId: string) =>
    `photovoltaic.string.${pvStringId}.power`;
  export const photovoltaicStringIdVoltage = (pvStringId: string) =>
    `photovoltaic.string.${pvStringId}.voltage`;

  // Battery
  export const batteryState = 'ess.battery.state';
  export const batteryOperationState = 'ess.operationState';
  export const batteryDischargeCumulated = 'ess.transfer.discharge.cumulated';
  export const inverterPower = 'ess.inverter.ac.power';
  export const inverterPowerConsolidated = 'ess.inverter.ac.power.consolidated';
  export const deviceSerial = 'device.serial';
  export const batteryInternalComponents = 'device.serial.internalComponents';
  export const batteries = 'ess.battery';
  export const power = 'ess.power';
  export const powerConsolidated = 'ess.power.consolidated';
  export const stateOfCharge = 'ess.stateOfCharge';
  export const stateOfChargeConsolidated = 'ess.stateOfCharge.consolidated';
  export const stateOfCapacityNominal = 'ess.battery.capacityNominal';
  export const stateOfCapacityNominalConsolidated = 'ess.battery.capacityNominal.consolidated';
  export const battery = (moduleId: string) => `ess.battery.${moduleId}`;
  export const batteryElectronicTracebealityNumber = (moduleId: string) =>
    `ess.battery.${moduleId}.etn`;
  export const batteryHardwareRevision = (moduleId: string) =>
    `ess.battery.${moduleId}.version.hardware`;
  export const batteryFirmware = (moduleId: string) => `ess.battery.${moduleId}.version.firmware`;
  export const batteryInformation = (id: string) => `ess.battery.${id}.information`;

  // ESS System
  export const ess = 'ess';
  export const essSystemType = 'ess.configuration.systemType';
  export const essFirmwareBundle = 'device.firmware.version';
  export const essGridFeedIn = 'pcc.transfer.feedIn.total';
  export const essGridConsumption = 'pcc.transfer.consumption.total';
  export const essGridTransferPowerExchange = 'pcc.transfer.power.exchange';
  export const essAmbientTemperature = 'ess.sensors.temperature.ambient';
  export const essEnergyMeter = (circuitId: string = '0') => `ess.meter.${circuitId}`;

  // Ess Configurations
  export const essFeatures = 'ess.features';
  export const essOptimalSelfConsumption = 'ess.features.optimalSelfConsumption';
  export const essBatterySleepMode = 'ess.features.batterySleepMode';
  export const essCyclicLoadCompressor = 'ess.features.cyclicLoadCompressor';
  export const essBackupReservedCapacity = 'ess.features.backupReservedCapacity';

  // Circuits
  export const circuits = 'heating.circuits';
  export const circuit = (circuitId: string) => `heating.circuits.${circuitId}`;
  export const circuitName = (circuitId: string) => `heating.circuits.${circuitId}.name`;
  export const circuitActiveMode = (circuitId: string) =>
    `heating.circuits.${circuitId}.operating.modes.active`;
  export const circuitOperatingMode = (circuitId: string, name: string) =>
    `heating.circuits.${circuitId}.operating.modes.${name}`;
  export const circuitActiveProgram = (circuitId: string) =>
    `heating.circuits.${circuitId}.operating.programs.active`;
  export const circuitHolidayProgram = (circuitId: string) =>
    `heating.circuits.${circuitId}.operating.programs.holiday`;
  export const circuitCurvePresets = (circuitId: string) =>
    `heating.circuits.${circuitId}.heating.curve.preset`;
  export const circuitRegulation = (circuitId: string) =>
    `heating.circuits.${circuitId}.regulation`;
  export const circuitHolidayAtHome = (circuitId: string) =>
    `heating.circuits.${circuitId}.operating.programs.holidayAtHome`;
  export const circuitSingleFamilyHolidayProgram = 'heating.operating.programs.holiday';
  export const circuitSingleFamilyHolidayAtHome = 'heating.operating.programs.holidayAtHome';
  export const circuitOperatingProgram = (circuitId: string, programName: string) =>
    `heating.circuits.${circuitId}.operating.programs.${programName}`;
  export const circuitHeatingCurve = (circuitId: string) =>
    `heating.circuits.${circuitId}.heating.curve`;
  export const circuitTemperature = (circuitId: string) =>
    `heating.circuits.${circuitId}.temperature`;
  export const circuitSupplyTemperature = (circuitId: string) =>
    `heating.circuits.${circuitId}.sensors.temperature.supply`;
  export const circuitCurrentTemp = (circuitId: string) =>
    `heating.circuits.${circuitId}.sensors.temperature.room`;
  export const circuitHeatingSchedule = (circuitId: string) =>
    `heating.circuits.${circuitId}.heating.schedule`;
  export const circuitSchedule = (circuitId: string, scheduleType: ScheduleType) =>
    `heating.circuits.${circuitId}.${scheduleType}.schedule`;
  export const circuitDhwSchedule = (circuitId: string) =>
    `heating.circuits.${circuitId}.dhw.schedule`;
  export const circuitCirculationSchedule = (circuitId: string) =>
    `heating.circuits.${circuitId}.circulation.schedule`;
  export const circuitCirculationPump = (circuitId: string) =>
    `heating.circuits.${circuitId}.circulation.pump`;
  export const circuitCirculationSecondaryPump = (circuitId: string) =>
    `heating.circuits.${circuitId}.circulation.secondaryPump`;
  export const circuitSensorsHumidityDewpoint = (circuitId: string) =>
    `heating.circuits.${circuitId}.sensors.humidity.dewpoint`;
  export const circuitSpaceClimateCooling = (circuitId: string) =>
    `heating.circuits.${circuitId}.cooling.hysteresis`;
  // Cooling heat pump
  export const circuitReducedCooling = (circuitId: string) =>
    `heating.circuits.${circuitId}.operating.programs.reducedCooling`;
  export const circuitReducedEnergySaving = (circuitId: string) =>
    `heating.circuits.${circuitId}.operating.programs.reducedEnergySaving`;
  export const circuitNormalCooling = (circuitId: string) =>
    `heating.circuits.${circuitId}.operating.programs.normalCooling`;
  export const circuitComfortCooling = (circuitId: string) =>
    `heating.circuits.${circuitId}.operating.programs.comfortCooling`;
  // Heating heat pump
  export const circuitReducedHeating = (circuitId: string) =>
    `heating.circuits.${circuitId}.operating.programs.reducedHeating`;
  export const circuitNormalHeating = (circuitId: string) =>
    `heating.circuits.${circuitId}.operating.programs.normalHeating`;
  export const circuitComfortHeating = (circuitId: string) =>
    `heating.circuits.${circuitId}.operating.programs.comfortHeating`;
  export const heatingCircuitRemoteController = (circuitId: string) =>
    `heating.circuits.${circuitId}.remoteController`;

  // Refrigerant circuit
  export const primaryCircuitAirInletTemperatue =
    'heating.primaryCircuit.sensors.temperature.supply';
  export const evaporationTemperature = 'heating.evaporators.0.sensors.temperature.liquid';
  export const suctionGasTemperature = 'heating.evaporators.0.sensors.temperature.overheat';
  export const compressorSuctionGasTemperature = 'heating.compressors.0.sensors.temperature.inlet';
  export const compressorLowPressureSensor = 'heating.compressors.0.sensors.pressure.inlet';

  export const hotGasTemperatureSensorCompressor =
    'heating.economizers.0.sensors.temperature.liquid';
  export const liquidGasTemperatureSensorCompressor =
    'heating.condensors.0.sensors.temperature.liquid';
  export const hotGasTemperatureSensorCompresssor =
    'heating.compressors.0.sensors.temperature.outlet';
  export const highPressureSensorCompressor = 'heating.compressors.0.sensors.pressure.outlet';

  export const Fan1ActualValue = 'heating.primaryCircuit.fans.0.current';
  export const Fan2ActualValue = 'heating.primaryCircuit.fans.1.current';
  export const electronicExpansionValve1Setpoint = 'heating.sensors.valve.0.expansion.target';
  export const electronicExpansionValve1ActualValue = 'heating.sensors.valve.0.expansion';
  export const electronicExpansionValve2Setpoint = 'heating.sensors.valve.1.expansion.target';
  export const electronicExpansionValve2ActualValue = 'heating.sensors.valve.1.expansion';

  // flow limit temperature
  export const flowLimitTemperature = (circuitId: string) =>
    `heating.circuits.${circuitId}.temperature.levels`;

  // Call For Heat
  export const callForHeatDemand = 'heating.callForHeat.demand';
  export const callForHeatHeatingCurvePresets = 'heating.callForHeat.heating.curve.presets';
  export const callForHeatConfigurationRegulation = 'heating.callForHeat.configuration.regulation';
  export const callForHeatHeatingCurve = 'heating.callForHeat.heating.curve';
  export const callForHeatSensorsTemperature = 'heating.callForHeat.sensors.temperature';
  export const callForHeatTemperature = 'heating.callForHeat.temperature';
  export const callForHeatPump = 'heating.callForHeat.pump';

  export const calculatedTemperatureOutside = 'system.calculated.temperature.outside';

  // Service
  export const serviceTimeBased = 'heating.service.timeBased';
  export const serviceBurnerBased = 'heating.service.burnerBased';

  // Geofencing
  export const circuitGeofencing = (circuitId: string) =>
    `heating.circuits.${circuitId}.geofencing`;

  // Heating zones
  export const circuitHeatingZone = (circuitId: string) => `heating.circuits.${circuitId}.zone`;
  export const circuitHeatingZoneDemand = (circuitId: string) =>
    `heating.circuits.${circuitId}.zone.demand`;
  export const circuitHeatingZoneMode = (circuitId: string) =>
    `heating.circuits.${circuitId}.zone.mode`;

  // Heat pump
  export const outdoorDefrosting = 'heating.outdoor.defrosting';
  export const heatingConsumptionCurrent = 'heating.power.consumption.current';
  export const heatingProductionCurrent = 'heating.heat.production.current';
  export const heatingProductionDhw = 'heating.heat.production.dhw';
  export const heatingProductionHeating = 'heating.heat.production.heating';
  export const heatingProductionCooling = 'heating.heat.production.cooling';
  export const heatingProductionTotal = 'heating.heat.production.total';
  export const heatPumpSmartGrid = 'heating.device.smartGrid';
  export const spaceFrostProtection = 'heating.primaryCircuit.spaceFrostProtection';
  export const spaceFrostProtectionConfiguration =
    'heating.primaryCircuit.configuration.spaceFrostProtection';
  export const frostProtection = 'heating.dhw.dhwCylinder.frostprotection';
  export const primaryCircuitConfigurationPreVentilation =
    'heating.primaryCircuit.configuration.preVentilation';

  // Cascades
  export const cascadeMemberId = 'device.cascade.memberId';
  export const cascadeMembers = 'heating.cascade.members';
  export const cascadeSequence = 'heating.cascade.configuration.sequence';
  export const cascadeSequenceStrategy = 'heating.cascade.configuration.sequence.strategy';
  export const cascadeDhwMode = 'heating.cascade.dhw.mode';
  export const cascadeHeatingCommonSupply = 'heating.cascade.temperature.commonSupply';
  export const cascadeMember = (memberId: string) => `heating.cascade.members.${memberId}`;
  export const cascadeLagDeviceSupplyTemperature = (memberId: string) =>
    `heating.cascade.members.${memberId}.sensors.temperature.supply`;
  export const cascadeLagDeviceBurnerStatus = (memberId: string) =>
    `heating.cascade.members.${memberId}.burner`;
  export const cascadeLagDeviceBurnerModulation = (memberId: string) =>
    `heating.cascade.members.${memberId}.burners.modulation.total`;

  // Eco water
  export const ecoWaterSaltLevelDays = 'water.softener.salt.level.days';
  export const deviceVariant = 'device.variant';
  export const leakDetection = 'water.leakDetection.configuration.flowAlert';

  // Buffer tank
  export const bufferCylinderOperatingModes = 'heating.bufferCylinder.operating.modes.active';
  export const bufferTankTemperatureMain = 'heating.bufferCylinder.sensors.temperature.main';

  // Wallbox
  export const wallboxChargingLimit = 'vcs.control.charging.limit.base';
  // https://wiki.viessmann-climatesolutions.com/display/VNXT/Vcs+charging+mode
  export const wallboxChargingMode = 'vcs.charging.mode';
  // https://wiki.viessmann-climatesolutions.com/display/VNXT/Vcs+Displayed+Power
  export const wallboxDisplayedPower = 'vcs.displayed.power';
  // https://wiki.viessmann-climatesolutions.com/pages/viewpage.action?spaceKey=VNXT&title=Vcs+Displayed+Substatus
  export const wallboxDisplayedSubstatus = 'vcs.displayed.substatus';
  export const wallboxDisplayedStatus = 'vcs.displayed.status';
  export const wallboxSessionCharging = 'vcs.session.charging';
  export const vehicleChargingStationAllowBatteryDischarge =
    'ems.hoca.features.vehicleChargingStationAllowBatteryDischarge';
  export const wallboxSessionPhases = 'vcs.session.phases';
  export const wallboxCapacityNominal = 'vcs.capacityNominal';
  export const wallboxStateOfCharge = 'vcs.stateOfCharge';
  export const wallboxSmartChargingMode = 'ems.control.vcs.0.charging.mode.smart';

  // Ecotronic
  export const heatingBoilerAshLevel = 'heating.boiler.ash.level.current';

  // Noise reduction
  export const heatingNoiseReduction = 'heating.noise.reduction';
  export const heatingNoiseReductionSchedule = 'heating.noise.reduction.schedule';
  export const heatingNoiseReductionOperatingProgram = (program: string) =>
    `heating.noise.reduction.operating.${program}`;
  export const heatingNoiseReductionOperatingState = 'heating.noise.reduction.operating.state';

  //Heater FanRing and Condensate Pan
  export const heatingHeaterFanring = 'heating.heater.fanRing';
  export const heatingHeaterCondensatePan = 'heating.heater.condensatePan';

  // Service Layer
  export const ventilationSensorsActuatorSelftest = 'ventilation.sensors.actuator.selftest';
  export const ventilationFilterInformation = 'ventilation.filter.information';
  export const ventilationLockExternal = 'ventilation.lockExternal';
  export const ventilationFanAssignmentSwitch = 'ventilation.fan.assignmentSwitch';
  export const ventilationSwitchActivation = 'ventilation.switchActivation';

  //EnergyStorage
  export const dlEssBatteryOperatingDataVoltage = (index: number) =>
    `dl.ess.battery.${index}.operating.data.voltage/value`;
  export const dlEssInverterAcPowerConsolidatedTotal =
    'dl.ess.inverter.ac.power.consolidated/total';
  export const dlEssPowerConsolidatedTotal = 'dl.ess.power.consolidated/total';
  export const dlEssInverterAcPowerConsolidatedItem = (index: number) =>
    `dl.ess.inverter.ac.power.consolidated/${index}`;
  export const dlEssPowerConsolidatedItem = (index: number) => `dl.ess.power.consolidated/${index}`;
  export const dlEssStateOfChargeConsolidatedTotal = 'dl.ess.stateOfCharge.consolidated/total';
  export const dlEssBatteryInformationStateOfCharge = (index: number) =>
    `dl.ess.battery.${index}.information/stateOfCharge`;
  export const dlEssStateOfChargeConsolidated = (index: number) =>
    `dl.ess.stateOfCharge.consolidated/${index}`;
  export const essBatteryOperatingDataTemperatureSensorsInternal = (
    batteryIndex: number,
    sensorIndex
  ) => `dl.ess.battery.${batteryIndex}.operating.data.temperature.sensors.internal/${sensorIndex}`;
  export const dlEssSensorsTemperatureAmbient = 'dl.ess.sensors.temperature.ambient/value';
  export const essInverterAcPowerActivePower = 'dl.ess.inverter.ac.power/activePower';
  export const essPowerValue = 'dl.ess.power/value';
  export const essStateOfChargeValue = 'dl.ess.stateOfCharge/value';

  // SCU device
  export const spaceOutsideTemperature = 'system.temperature.outside';
  export const overarchingStandby = 'system.quickmodes.standby';

  // Dry conctacs
  export const dryContactInstantaneousPower = 'dryContact.power.instantaneousPower';
  export const dryContactPowerConsumptionStatus = 'dryContact.power.consumption.status';
  export const dryContactPowerNominal = 'dryContact.power.nominal';
  export const dryContactOutputSetpoint = 'dryContact.output.setpoint';

  // HEMS
  export const hemsConfigurationOverview = 'hems.configuration.overview';
}

// https://viessmann.atlassian.net/wiki/spaces/ORS/pages/1855193090/SWADR-5+Evolve+IoT-C+API+for+OBNG
export const featureToInterfaceRole = {
  // commissioning;basic
  'device.commissioning': {
    role: 'commissioning;basic',
    multi: true,
  },
  'device.commissioning.information': {
    role: 'commissioning;basic',
    multi: true,
  },
  'device.installation.date': {
    role: 'commissioning;basic',
    multi: true,
  },
  'device.commissioning.client': {
    role: 'commissioning;basic',
    multi: true,
  },
  // commissioning;system
  'commissioning;system': {
    role: 'device.productMatrix',
    multi: true,
  },
  'heating.cascade.members.': {
    role: 'commissioning;basic',
    multi: true,
  },
  'device.busTopology': {
    role: 'commissioning;basic',
    multi: true,
  },
  'device.capabilities': {
    role: 'commissioning;basic',
    multi: true,
  },
  // commissioning;building
  'device.buildingType': {
    role: 'commissioning;building',
    multi: true,
  },
  'heating.configuration.multiFamilyHouse': {
    role: 'commissioning;building',
    multi: true,
  },
  'device.configuration.houseLocation': {
    role: 'commissioning;building',
    multi: true,
  },
  // commissioning;display
  'device.hmi.language': {
    role: 'commissioning;display',
    multi: true,
  },
  'device.hmi.unitsAndFormats': {
    role: 'commissioning;display',
    multi: true,
  },
  // commissioning;dateTime
  'heating.device.time.source': {
    role: 'commissioning;dateTime',
    multi: true,
  },
  'heating.device.time': {
    role: 'commissioning;dateTime',
    multi: true,
  },
  'device.time.offset': {
    role: 'commissioning;dateTime',
    multi: true,
  },
  'device.timezone.offset': {
    role: 'commissioning;dateTime',
    multi: true,
  },
  'device.time.daylightSaving': {
    role: 'commissioning;dateTime',
    multi: true,
  },
  // commissioning;combustion
  'heating.gas.configuration.type': {
    role: 'commissioning;combustion',
    multi: true,
  },
  'heating.exhaustSystem.mode': {
    role: 'commissioning;combustion',
    multi: true,
  },
  'heating.exhaustSystem.dimensions': {
    role: 'commissioning;combustion',
    multi: true,
  },
  // zigbee
  'device.zigbee': {
    role: 'zigbee',
    multi: true,
  },
  // commissioning;thermal
  'device.systemSetup.hydraulic': {
    role: 'commissioning;thermal',
    multi: true,
  },
  // commissioning;electrical
  'device.systemSetup.energyMatrix': {
    role: 'commissioning;electrical',
    multi: true,
  },
};

export enum ScheduleType {
  Circulation = 'circulation',
  Heating = 'heating',
  Dhw = 'dhw',
  Ventilation = 'ventilation',
}

export enum DhwScheduleModes {
  Dhw = 'dhw',
  DhwAndHeating = 'dhwAndHeating',
  DhwAndHeatingCooling = 'dhwAndHeatingCooling',
}

export enum EssSystemType {
  nothing = 'nothing',
  hybrid = 'hybrid',
  photovoltaic = 'photovoltaic',
  battery = 'battery',
}

export const heatingCurcuitStandbyMode = 'standby';

namespace FeatureCommands {
  export const setTargetTemperature = 'setTargetTemperature';
  export const setZigbeeController = 'setZigbeeController';
  export const removeZigbeeController = 'removeZigbeeController';
  export const setChangeableByEndCustomer = 'setChangeableByEndCustomer';
  export const setTemperature = 'setTemperature';
  export const enable = 'enable';
  export const disable = 'disable';
  export const setActive = 'setActive';
  export const setCurve = 'setCurve';
  export const setType = 'setType';
  export const setName = 'setName';
  export const setValue = 'setValue';
  export const setHysteresis = 'setHysteresis';
  export const setHysteresisSwitchOnValue = 'setHysteresisSwitchOnValue';
  export const setHysteresisSwitchOffValue = 'setHysteresisSwitchOffValue';
  export const activate = 'activate';
  export const deactivate = 'deactivate';
  export const grant = 'grant';
  export const revoke = 'revoke';
  export const activateManually = 'activateManually';
  export const deactivateManually = 'deactivateManually';
  export const setSchedule = 'setSchedule';
  export const setMode = 'setMode';
  export const schedule = 'schedule';
  export const unschedule = 'unschedule';
  export const setThresholds = 'setThresholds';
  export const setConcentration = 'setConcentration';
  export const assignHeatingCircuit = 'assignHeatingCircuit';
  export const setHourInterval = 'setHourInterval';
  export const setTime = 'setTime';
  export const remove = 'remove';
  export const reboot = 'reboot';
  export const remoteReset = 'remoteReset';
  export const setMax = 'setMax';
  export const triggerOncePerWeek = 'triggerOncePerWeek';
  export const triggerDaily = 'triggerDaily';
  export const clearCacheAndReboot = 'clearCacheAndReboot';
  export const setTimezone = 'setTimezone';
  export const update = 'update';
  export const setState = 'setState';
  export const setLevels = 'setLevels';
  export const setDefaultLevels = 'setDefaultLevels';
  export const confirmService = 'confirmService';
  export const setMinimalFilling = 'setMinimalFilling';
  export const setTariff = 'setTariff';
  export const setEnergyFactor = 'setEnergyFactor';

  // Commissioning - Add room
  export const add = 'add';
  // Commissioning - add/remove device
  export const addDevice = 'addDevice';
  export const removeDevice = 'removeDevice';
  // Commissioning - pairing device
  export const addActor = 'addActor';
  export const removeActor = 'removeActor';
  export const moveActor = 'moveActor';

  // Remote diagnostics
  export const open = 'open';
  export const close = 'close';

  // Hybrid Control Pro
  export const setMinTemperature = 'setMinTemperature';
  export const setMaxTemperature = 'setMaxTemperature';
  export const setDelayTime = 'setDelayTime';
  export const setBreakTime = 'setBreakTime';
  export const setMinimalRuntime = 'setMinimalRuntime';

  // Wallbox
  export const setStateOfCharge = 'setStateOfCharge';
  export const setTimer = 'setTimer';
}

export enum StatusValueDcFeature {
  connected = 'connected',
  error = 'error',
  notConnected = 'notConnected',
}

export enum DiverterValve {
  dhw = 'dhw',
  heating = 'heating',
  middle = 'middle',
  driving = 'driving',
}
namespace FeatureActionFields {
  export const type = 'type';
  export const slope = 'slope';
  export const shift = 'shift';
  export const deviceId = 'deviceId';
  export const activationThreshold = 'activationThreshold';
  export const deactivationThreshold = 'deactivationThreshold';
  export const temperature = 'temperature';
  export const targetTemperature = 'targetTemperature';
  export const hysteresis = 'hysteresis';
  export const newSchedule = 'newSchedule';
  export const changeable = 'changeable';
  export const timeout = 'timeout';
  export const concentration = 'concentration';
  export const mode = 'mode';
  export const value = 'value';
  export const state = 'state';
  export const minimumLevel = 'minimumLevel';
  export const maximumLevel = 'maximumLevel';
  export const active = 'active';
  export const turnOn = 'turnOn';
  export const minTemperature = 'minTemperature';
  export const maxTemperature = 'maxTemperature';
  export const delayTime = 'delayTime';
  export const breakTime = 'breakTime';
  export const minimalRuntime = 'minimalRuntime';
}

export enum FeaturePropertyKey {
  active = 'active',
  activeHemsType = 'activeHemsType',
  activePower = 'activePower',
  activated = 'activated',
  activationThreshold = 'activationThreshold',
  actorDeviceId = 'actorDeviceId',
  actualState = 'actualState',
  adjustWeight = 'adjustWeight',
  autarky = 'autarky',
  averageUsableSystemEnergy = 'averageUsableSystemEnergy',
  basic = 'basic',
  blocked = 'blocked',
  build = 'build',
  burnerHoursUntilNextService = 'burnerHoursUntilNextService',
  countCoulombCharge = 'countCoulombCharge',
  calculationStatus = 'calculationStatus',
  concentration = 'concentration',
  current = 'current',
  currentDay = 'currentDay',
  currentMonth = 'currentMonth',
  currentState = 'currentState',
  currentYear = 'currentYear',
  deactivationThreshold = 'deactivationThreshold',
  defaultLimit = 'defaultLimit',
  devices = 'devices',
  electricityInput = 'electricityInput',
  enabled = 'enabled',
  energy = 'energy',
  entries = 'entries',
  exception = 'exception',
  setChangeableByEndCustomer = 'setChangeableByEndCustomer',
  family = 'family',
  gridToConsumption = 'gridToConsumption',
  gridToStorage = 'gridToStorage',
  hysteresis = 'hysteresis',
  lastService = 'lastService',
  lastSevenDays = 'lastSevenDays',
  lastMonth = 'lastMonth',
  lastYear = 'lastYear',
  level = 'level',
  level1 = 'level1',
  level2 = 'level2',
  level3 = 'level3',
  libraryVersion = 'libraryVersion',
  libraryType = 'libraryType',
  lifeCycle = 'lifeCycle',
  heatingCircuit = 'heatingCircuit',
  hour = 'hour',
  hours = 'hours',
  hoursLoadClassOne = 'hoursLoadClassOne',
  hoursLoadClassTwo = 'hoursLoadClassTwo',
  hoursLoadClassThree = 'hoursLoadClassThree',
  hoursLoadClassFour = 'hoursLoadClassFour',
  hoursLoadClassFive = 'hoursLoadClassFive',
  minutes = 'minutes',
  max = 'max',
  maxFlow = 'maxFlow',
  maxUnit = 'maxUnit',
  maxDuration = 'maxDuration',
  maximumLevel = 'maximumLevel',
  maximumLimit = 'maximumLimit',
  mode = 'mode',
  min = 'min',
  minUnit = 'minUnit',
  minimalFilling = 'minimalFilling',
  minimumLevel = 'minimumLevel',
  minimumLimit = 'minimumLimit',
  name = 'name',
  nextService = 'nextService',
  online = 'online',
  operatingHours = 'operatingHours',
  operationHours = 'operationHours',
  overall = 'overall',
  overdueHours = 'overdueHours',
  overloadProtectionActive = 'overloadProtectionActive',
  perceivedTemperature = 'perceivedTemperature',
  productionHours = 'productionHours',
  productionStarts = 'productionStarts',
  productionToConsumption = 'productionToConsumption',
  productionToStorage = 'productionToStorage',
  productionToGrid = 'productionToGrid',
  photovoltaicExcessNotSufficient = 'photovoltaicExcessNotSufficient',
  position = 'position',
  power = 'power',
  present = 'present',
  product = 'product',
  properties = 'properties',
  reactivePower = 'reactivePower',
  requestedState = 'requestedState',
  remaining = 'remaining',
  remainingHours = 'remainingHours',
  revision = 'revision',
  serviceIntervalBurnerHours = 'serviceIntervalBurnerHours',
  selfConsumption = 'selfConsumption',
  shift = 'shift',
  slope = 'slope',
  storageToConsumption = 'storageToConsumption',
  storageToStorage = 'storageToStorage',
  storageToGrid = 'storageToGrid',
  stateOfHealth = 'stateOfHealth',
  stateOfCharge = 'stateOfCharge',
  startHour = 'startHour',
  startMinute = 'startMinute',
  substatus = 'substatus',
  starts = 'starts',
  state = 'state',
  status = 'status',
  strength = 'strength',
  temperature = 'temperature',
  thermalOutput = 'thermalOutput',
  timeout = 'timeout',
  total = 'total',
  uid = 'uid',
  updateStatus = 'updateStatus',
  usableEnergyModuleOne = 'usableEnergyModuleOne',
  usableEnergyModuleTwo = 'usableEnergyModuleTwo',
  usableEnergyModuleThree = 'usableEnergyModuleThree',
  usableEnergyModuleFour = 'usableEnergyModuleFour',
  usableEnergyModuleFive = 'usableEnergyModuleFive',
  usableEnergyModuleSix = 'usableEnergyModuleSix',
  useApproved = 'useApproved',
  value = 'value',
  version = 'version',
  vinList = 'vinList',
  volumeFlow = 'volumeFlow',
  target = 'target',
  time = 'time',
  timer = 'timer',
  type = 'type',
  weekdays = 'weekdays',
  weekday = 'weekday',
  defaultRuntime = 'defaultRuntime',
  busType = 'busType',
  deviceId = 'deviceId',
  deviceIndex = 'deviceIndex',
  circuitsEnabled = 'circuitsEnabled',
  filterRuntimeResetValue = 'filterRuntimeResetValue',
  filterOneEan = 'filterOneEan',
  filterTwoEan = 'filterTwoEan',
  airPressureMonitor = 'airPressureMonitor',
  fireProtectionFlap = 'fireProtectionFlap',
  limitations = 'limitations',
  subscriptionActive = 'subscriptionActive',
  price = 'price',
  factor = 'factor',
  minTemperature = 'minTemperature',
  maxTemperature = 'maxTemperature',
  delay = 'delay',
  break = 'break',
  minimal = 'minimal',

  // add more properties from DC here when discovered ( alphabetically! )
}

export { FeatureActionFields, FeatureCommands, FeatureNames };

export const InterceptorSkipHeader = 'X-Skip-Interceptor';

export const configHeatOnTime = '.configuration.heatOnTime';

export enum PowerLimitationType {
  consumption = 'consumption',
  production = 'production',
}

export enum PowerLimitationMethod {
  hems = 'hems',
  direct = 'direct',
}

export enum HemsType {
  LiteReady = 'LiteReady',
  Lite = 'Lite',
  Full = 'Full',
  None = 'None',
  NotConfigured = 'NotConfigured',
}

export const heatingCircuitRemoteRegex = /^heating\.circuits\.\d+\.remoteController$/;

export const RemoteDescription: string[] = [
  '+ADDITIONAL.SERVICE.FEATURE.PERMANENT_REMOTE_INSPECTION',
  '+ADDITIONAL.SERVICE.FEATURE.REMOTE_OPTIMIZATIONS',
  '+ADDITIONAL.SERVICE.FEATURE.ANNUAL_INSPECTION_REPORTS',
  '+ADDITIONAL.SERVICE.FEATURE.INCIDENT_AND',
  '+ADDITIONAL.SERVICE.FEATURE.MAINTENANCE_COORDINATION',
];

export const VorOrtDescription: string[] = [
  '+ADDITIONAL.SERVICE.FEATURE.MAINTENANCE',
  '+ADDITIONAL.SERVICE.FEATURE.REPAIR',
];

export const AdditionalServiceConfig = [
  {
    colorClass: 'vi-battleshipgrey-section',
    isRemote: true,
    title: '+ADDITIONAL.SERVICE.FEATURE.SPECIALIST_PARTNER',
    subTitle: '+ADDITIONAL.SERVICE.FEATURE.WITH_VIGUIDEPRO',
  },
  {
    colorClass: 'vi-battleshipgrey-section',
    isRemote: false,
    title: '+ADDITIONAL.SERVICE.FEATURE.SPECIALIST_PARTNER',
    subTitle: '',
  },
  { colorClass: 'vi-orange-section', isRemote: true, title: null, subTitle: null },
  { colorClass: 'vi-orange-section', isRemote: false, title: null, subTitle: null },
];
